import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { PreviewGate } from '@/components/feature/PreviewGate'
import { BrandPatternProvider } from '@/context/BrandPatternContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrandPatternProvider>
      <PreviewGate>
        <App />
      </PreviewGate>
    </BrandPatternProvider>
  </StrictMode>,
)
